import Vue from 'vue'
import moment from 'moment-timezone/builds/moment-timezone-with-data-2012-2022'

const defaultZone = moment.tz.guess()

export default Vue.filter('moment', (date, format) => {
  moment.locale(Vue.config.language)
  return moment(date).tz(Vue.config.timezone || defaultZone).format(format)
})



// WEBPACK FOOTER //
// ./src/filters/moment.js